import type { CsvRow } from "../types";

// Group rows by UTC calendar year. Returns a Map ordered by year ascending.
export function groupByYear(rows: CsvRow[]): Map<number, CsvRow[]> {
  const buckets = new Map<number, CsvRow[]>();
  for (const row of rows) {
    const year = row.timestamp.getUTCFullYear();
    let bucket = buckets.get(year);
    if (!bucket) {
      bucket = [];
      buckets.set(year, bucket);
    }
    bucket.push(row);
  }
  const sorted = new Map<number, CsvRow[]>();
  for (const year of Array.from(buckets.keys()).sort((a, b) => a - b)) {
    sorted.set(year, buckets.get(year)!);
  }
  return sorted;
}
